// extracted by mini-css-extract-plugin
module.exports =  {"container":"AxisUnit-module__container--yESGO","label":"AxisUnit-module__label--flHNh","badge":"AxisUnit-module__badge--S80kI"};